import axios from 'axios';
import {
  api_sign_fn
} from './api_sign';
import {
  config
} from './config';
import store from '@/store';
import { delCookie } from "@/utils/util";
import Vue from 'vue';
import router from '../router';

// 请求拦截器
axios.interceptors.request.use(conf => {
  // const token = store.state.user.token;
  var url = conf.url;
  if (conf.method == 'get') {
    // params有值时
    if (conf.params) {
      var params = JSON.parse(JSON.stringify(conf.params))
      if (params.api_sign) {
        delete params.api_sign;
      }
      var api_sign = api_sign_fn.make_sign(config.root_host + url, {
        app_id: config.app_id,
        ...params
      });
      conf.params.app_id = config.app_id;
      conf.params.api_sign = api_sign;
      // conf.params.config_type = 1;
      // if (token) conf.params.token = token;
    } else {
      var api_sign = api_sign_fn.make_sign(config.root_host + url, {
        app_id: config.app_id
      });
      conf.params = {
        app_id: config.app_id,
        api_sign: api_sign,
        // config_type: 1
      };
      // if (token) {
      //   conf.params.token = token
      // }
    }
  } else if (conf.method == 'post') {
    var params = JSON.parse(JSON.stringify(conf.data));
    if (params.api_sign) {
      delete params.api_sign;
    }
    var api_sign = api_sign_fn.make_sign(config.root_host + url, {
      app_id: config.app_id,
      ...params
    });
    conf.data.app_id = config.app_id;
    conf.data.api_sign = api_sign;
    // conf.data.config_type = 26;
    // conf.data.config_type = 17;
    // if (token) conf.data.token = token
  }
  return conf;
})
// 返回数据拦截
axios.interceptors.response.use(
  async response => {
      const data = response.data;
      if(data.code == 400){
        Vue.prototype.$message({
          message: data.message,
          type: 'warning'
        });
        delCookie();
        // store.commit("user/SET_TOKENNUll",null);
        // store.commit("user/SET_EMAILNULL",null);
        router.push({
          path: "/login",
        });
      }else{
        return data
      }
    },
    function (error) {
      var newError = String(error);
      if (newError.indexOf('400') > -1) {
        // store.commit("user/SET_ERR");
        // Dialog({
        //   message: '当前登录已过期，请退出重新登录！'
        // });
      }
      // 对响应错误做点什么
      return Promise.reject(error)
    }
)

export default axios



// WEBPACK FOOTER //
// ./src/utils/request.js